// Get the entire settings object (or {} if not set / malformed)
export const loadSystemSettings = () => {
    try {
      return JSON.parse(localStorage.getItem('systemSettings')) || {};
    } catch (e) {
      console.error('Invalid JSON in systemSettings:', e);
      return {};
    }
}
  
// Retrieve posClientId (or null if missing)
export const getPosClientIdFromStorage = () => {
    const settings = loadSystemSettings();
    return settings.posClientId || null;
}
  
// Retrieve cdsClientId (or null if missing)
export const getCdsClientIdFromStorage = () => {
    const settings = loadSystemSettings();
    return settings.cdsClientId || null;
}
  